<div class="frame">
  <div class="login">
    <img src="/assets/login/logo.png" class="logo" />
    <span class="name">Store Analytics</span>
    @if (isLoading) {
      <mat-progress-bar mode="indeterminate" class="loading"></mat-progress-bar>
    }
    <form [formGroup]="model">
      <mat-form-field>
        <input matInput formControlName="email" />
        <mat-label>E-mail</mat-label>
        @if (showErr === 'required') {
          <mat-error> E-mail is required! </mat-error>
        }
        @if (showErr === 'email') {
          <mat-error>Invalid E-mail entered!</mat-error>
        }
        @if (showErr === 'notAllowedEmail') {
          <mat-error> E-mail is not allowed for {{ isDemoEnv ? 'demo' : 'app' }} </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <input matInput type="password" formControlName="password" />
        <mat-label>Password</mat-label>
        @if (model.controls.password.hasError('required')) {
          <mat-error> Password is required! </mat-error>
        }
        @if (model.controls.password.hasError('wrongPassword')) {
          <mat-error> Wrong E-mail or password! </mat-error>
        }
      </mat-form-field>

      <div class="actions">
        <button mat-raised-button type="submit" color="primary" (click)="login()">Login</button>
      </div>

      <div class="copyright">
        © {{ year }} Pygmalios. All rights reserved
        <a class="cookie-settings" (click)="openCookieSettings()">
          {{ 'cookie_consent.settings.title' | translate }}
        </a>
      </div>
    </form>
  </div>
  <div class="info"></div>
</div>
